// Context

import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import { getCustomOfferPriceList } from "./api";

type Context = {
  // dane z API (lista cenników)

  data: any;
  // dane z API (metadane)
  meta: any;

  // dodatkowe parametry zapytania
  additionalData: {
    get: string[];
    set: (value: string[]) => void;
    add: (value: string) => void;
  };

  // refetch danych
  refreshData: () => void;
};

const Context = createContext<Context | null>(null);

export const Provider = ({ children }: { children: any }) => {
  const [data, setData] = useState<any>(null);
  const [meta, setMeta] = useState<any>(null);
  const [additionalData, setAdditionalData] = useState<string[]>([]);

  const refreshData = useCallback(() => {
    setData(null);
    getCustomOfferPriceList(additionalData)
      .then((e) => e.json())
      .then((e) => {
        setData(e.data ?? []);
        setMeta(e.meta);
      });
  }, [additionalData]);

  useEffect(() => {
    if (additionalData.length > 0) refreshData();
  }, [additionalData]);

  return (
    <Context.Provider
      value={{
        data,
        meta,
        additionalData: {
          get: additionalData,
          set: (e) => setAdditionalData(e),
          add: (e) => setAdditionalData([...additionalData, e]),
        },
        refreshData: refreshData,
      }}
    >
      {children}
    </Context.Provider>
  );
};

export const useViewOfferPriceListContext = () => {
  const context = useContext(Context);
  if (context === null) {
    throw new Error(
      "useViewOfferPriceListContext must be used within a Provider"
    );
  }
  return context;
};
